import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { useDispatch } from 'react-redux';

// COMPONENTS & UTILS
import theme from 'styles/mui/theme';
import { useGetUserDetailQuery } from 'services/private/user';
import { getUserDetail } from 'store/slices/authSlice';
import performClientLogout from 'utilities/clientLogout';
import GlobalLoader from 'containers/common/loaders/GlobalLoader';
import AppRoutes from './routes';

function App() {
  const dispatch = useDispatch();
  const hasToken = Boolean(localStorage.getItem('token'));
  const { isSuccess, data: response, isLoading, isError, error } = useGetUserDetailQuery(undefined, {
    skip: !hasToken,
  });

  useEffect(() => {
    if (!hasToken) {
      return;
    }

    if (response && isSuccess && !isLoading) {
      dispatch(getUserDetail(response?.data));
    } else if (isError && !isLoading && (error?.status === 401 || error?.status === 403)) {
      if (localStorage.getItem('token')) {
        performClientLogout(dispatch);
      }
    } else if (isError && !isLoading) {
      // Non-auth errors (network errors, aborts, timeouts) - preserve token
      // eslint-disable-next-line no-console
      console.warn('Non-authentication error occurred:', error);
    }
  }, [dispatch, error, hasToken, isError, isLoading, isSuccess, response]);

  if (hasToken && isLoading) {
    return <GlobalLoader />;
  }

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider preventDuplicate anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <AppRoutes />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
